






import { Component, Vue } from 'vue-property-decorator'
import UserService from '@/services/UserService'

@Component({
  name: 'ExitImpersonate'
})
export default class ExitImpersonate extends Vue {
  async exitImpersonation (): Promise<void> {
    this.$store.commit('user/unImpersonated')
    await this.$auth.logout()
    await UserService.logout()
    await this.$router.push({ name: 'home' })
  }
}
